import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
// import { authenticated } from './login.service';
// Servicios
import { CommonService } from './common.service';
import { NotifyService } from '../notify/notify.service';
import { BreadCrumbsService } from './breadcrumbs.service';
import { IBreadCrumbs } from 'src/app/models/interfaces/common/IBreadcrumbs';
// import { AccionesPantalla } from '../../models/interfaces/AccionesPantalla';
import { EncryptedService } from './encrypted.services';

@Injectable()
export class CanActivateService implements CanActivate, OnDestroy {
  public routes: Array<IBreadCrumbs> = [];
  public lastModule: string;
  public prevPantalla: string;

  constructor(
    private _commonService: CommonService,
    private _notifyService: NotifyService,
    private _breadCrumbs: BreadCrumbsService,
    private _encrypted: EncryptedService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true

    // const url = '#' + state.url;
    // const name = route.data.breadCrumbs;
    // const modulo: string = route.data.modulo;

    // sessionStorage.setItem('ruta?', 's');

    // this.lastModule = this._encrypted.decrypted(sessionStorage.getItem('lastModule'));

    // if (this._login.isAuthenticated()) {
    //   // if (this.permisosRol(route.data.Pantalla)) {
    //   if (modulo !== this.lastModule && modulo !== undefined) {
    //     sessionStorage.setItem('lastModule', this._encrypted.encrypted(modulo));

    //     this._breadCrumbs.resetModule();

    //     if (name) {
    //       this._breadCrumbs.MyBreadCrumbs(url, name);
    //       if (name !== 'Home') {
    //         // this.permisosRol(state.url);
    //       }
    //     }
    //   } else {
    //     if (name) {
    //       this._breadCrumbs.MyBreadCrumbs(url, name);
    //       if (name !== 'Home') {
    //         // this.permisosRol(state.url);
    //       }
    //     }
    //   }

    //   return true;
    //   // }
    // } else {
    //   this._login.closeSession(true);
    // }

  }

  getParams(route: any) {
    let params = Object.assign({}, route.value.params || {});

    if (route.children.length > 0) {
      params = Object.assign(params, this.getParams(route.children[0]));
    }

    return params;
  }

  ngOnDestroy() {
  }
}
